import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { DependentsService } from "src/app/services/dependents.service";

import { DocumentStatusDialogModel } from "src/app/models/dialog";
import { DependentDocumentsStatusModel, DependentDocumentsStautsPayload } from "src/app/models/dependent-grid";
import { TableColumn } from "src/app/models/table";
import { TableColumnType } from "src/app/constants/table";
import { MatTableDataSource } from "@angular/material/table";
import { DocumentStatus } from "src/app/models/document";

@Component({
    selector: 'mwp-dialog-document-status',
    templateUrl: './document-status.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogDocumentStatusComponent implements OnInit {

    public dependentName: string;

    public documentMatTableData: MatTableDataSource<DocumentStatus>;
    public documentColumns: TableColumn[] = [
        {
            columnName: 'Document',
            propertyId: 'documentName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Received On',
            propertyId: 'receivedDate',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Reviewed On',
            propertyId: 'reviewedDate',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Status',
            propertyId: 'status',
            columnType: TableColumnType.label,
        },
    ];

    constructor(
        private dialogRef: MatDialogRef<DialogDocumentStatusComponent>,
        private dependentService: DependentsService,
        @Inject(MAT_DIALOG_DATA) public documentStatusDialogModel: DocumentStatusDialogModel,
    ) {
    }

    ngOnInit(): void {

        if (this.documentStatusDialogModel.isDependentVerification) {
            const l_DependentDocumentsStautsPayload: DependentDocumentsStautsPayload = {
                id: this.documentStatusDialogModel.dependentId,
            };
            this.dependentService.getDependentDocumentsStatus(l_DependentDocumentsStautsPayload).subscribe((response: DependentDocumentsStatusModel) => {
                this.dependentName = response.dependentName;

                const l_DocumentStatuses = new Array<DocumentStatus>();

                response.documents.forEach((d) => {
                    let l_DocumentStatus = new DocumentStatus();
                    l_DocumentStatus.documentName = d.documentName;
                    l_DocumentStatus.receivedDate = d.receivedDate;
                    l_DocumentStatus.reviewedDate = d.reviewedDate;

                    if (d.documentIsPending) {
                        l_DocumentStatus.status = 'Pending';
                    } else if (d.documentIsRejected) {
                        l_DocumentStatus.status = 'Rejected';
                    } else if (d.documentIsVerified) {
                        l_DocumentStatus.status = 'Approved';
                    }

                    l_DocumentStatuses.push(l_DocumentStatus);
                });

                this.documentMatTableData = new MatTableDataSource<DocumentStatus>();
                this.documentMatTableData.data = l_DocumentStatuses;
            });
        }
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}